import Flex from '~/common/components/Flex';
import { useUser } from '~/common/hooks/useAuthentication';
import AISwitchToggle from '~/common/mui/Switch/SwitchAI/AISwitchToggle';

import { StyledHeading } from './styledComponents/styledComponents';
import ProcessedText from './utilityComponents/ProcessedText';

type HeadingProps = {
  text?: string;
  headingSize?: 'large' | 'small';
  isPlain?: boolean;
  isCompact?: boolean;
  hasAiSwitch?: boolean;
  sx?: Record<string, unknown>;
  placeholders?: any[];
  id?: string;
  testId?: string;
  children?: React.ReactNode;
};

function HeadingAiSwitch() {
  const { isUnderwriter } = useUser();
  if (!isUnderwriter) return null;
  return (
    <Flex>
      <AISwitchToggle sessionStorageEnabled />
    </Flex>
  );
}

/**
 * Heading component that renders a heading based on the type.
 */
export default function Heading({
  text,
  placeholders = [],
  id = '',
  testId = 'heading',
  headingSize = 'small',
  isPlain = false,
  isCompact = false,
  hasAiSwitch = false,
  sx,
  children,
}: Readonly<HeadingProps>) {
  return (
    <StyledHeading
      isSectionHeader={headingSize === 'large'}
      isPlain={isPlain}
      isCompact={isCompact}
      sx={sx}
      data-testId={testId}
    >
      <ProcessedText text={text} placeholders={placeholders} name={id} />
      {children && <Flex>{children}</Flex>}
      {hasAiSwitch && <HeadingAiSwitch />}
    </StyledHeading>
  );
}
